import React from 'react';
import { useSelector } from 'react-redux';

import './MobileDownloadConversation.pcss';
import { ModalHeader } from '../modal-helpers';
import { activeChatbotIdSelector } from '@mm/state/selectors/viewSelectors';

type OuterProps = {
  remoteUserId: string | undefined;
};

export const MobileDownloadConversation = (props: OuterProps) => {
  const { remoteUserId } = props;

  const chatbotId = useSelector(activeChatbotIdSelector);

  return (
    <div className="mobile-app-download-modal__gradient">
      <ModalHeader className="mobile-app-download-modal__close" />
      <div className="mobile-app-download-modal__text">
        View your conversations in our new mobile app!
      </div>
      <a
        className="mobile-app-download-modal__button"
        href={`https://app.mobilemonkey.com/chatbot-editor/${chatbotId}/live-chat/${remoteUserId}`}
        target={'_blank'}
      >
        Download App
      </a>
    </div>
  );
};
